import React from 'react';
import styles from './font-not-found.scss';

const FontNotFound = () => {
  return (
    <div className={styles.container}>
      <span className={styles.heading}>
        Oops, there is no font with that name.
      </span>
      <span className={styles.subHeading}>
        Try searching for a different font in the library.
      </span>
    </div>
  );
};

export default FontNotFound;


// WEBPACK FOOTER //
// ./src/fonts/font-picker/font-list/font-not-found.jsx